module.exports = __webpack_public_path__ + "public/SiteIcons/chevron-right.svg?f44ed2ce";